import { createSelector } from 'reselect'

import { getRequestStatus } from '@cinch/oxd-utils/request-status/src'

const getListingsStatus = (state: any) => state.entities && state.entities.dealerListings.fetchStatus
const getSearchStatus = (state: any) => state.dealerVehicle && state.dealerVehicle.searchStatus

export default createSelector(getListingsStatus, getSearchStatus, (listings, search) => ({
  listingsStatus: getRequestStatus(listings),
  searchStatus: getRequestStatus(search),
}))
